import { Stack } from '@mui/material'
import { IGroupEntity } from 'models'
import { Indicators } from '../indicators/Indicators'
import GroupSpecificInfo from './components/GroupSpecificInfo'

export const MainInfo = (props: IGroupEntity) => {
	return (
		<Stack direction='column' height='100%' minWidth='100%' gap='24px'>
			<GroupSpecificInfo {...props} />
			<Indicators {...props} />
		</Stack>
	)
}
